import React, { Component } from 'react';

import { s3CacheUrl } from '../Common/util';

export class ZuckerQuote extends Component {
  render() {
    return(
      <div className={"collabs-banner-quote zucker-fg tile is-5"}>
        {`“I’m very invested in material choices and manipulations. My work is derived from the relationship of digital processes to physical ones, and materials become very important in that conversation.”`}
        <div className={"collabs-banner-byline"}>
          —Kevin Zucker
        </div>
      </div>
    );
  }
}

export class ZuckerBio extends Component {
  render() {
    return(
      <div className={"collabs-bio"}>
        <div className={"collabs-divider zucker-bg"} />

        <div className={"collabs-section white white tile is-ancestor"}>
          <div className={'collabs-bio-image-container tile is-5'}>
            <img className={"collabs-bio-image"} alt={"Kevin Zucker"} src={s3CacheUrl("https://s3.amazonaws.com/weft-public-assets/images/weft-shop-collab/zucker/zucker1weft-artist-portrait-388x350.jpg", 350)} />
          </div>
          <div className={"collabs-bio-header tile is-5"}>
            <h1>The Interrelationship of Digital and Material</h1>
            <p>Often using three-dimensional models as his source material, Kevin Zucker’s work explores the implications of translating digital to material.</p>
          </div>
        </div>

        <div className={"collabs-section grey"}>
          <div className={"bio-content"}>
            <p>Through his paintings, drawings, sculpture, and photographs, Zucker seeks to highlight the 
            fraught interrelationship between the digital and physical worlds. In creating his work, 
            he frequently begins by manipulating existing digital material, such as three-dimensional 
            models. On the process, he explains, “I like the idea of a digital file as a kind of 
            assisted readymade. I think there’s something compelling in repurposing online detritus 
            that was intended for a very different kind of use or consumption.”</p>
 
            <p>For his collaboration with Weft, Zucker sought to create a “true” repetitive pattern, 
            something that required significant deliberation. “I wanted the fact of the 
            repetition to be meaningful, and for the subject to be something that got both 
            sadder and funnier by virtue of the fact that it could, in theory, be 
            extended infinitely in every direction,” he says. His selection of raindrops 
            was intentionally tragicomic. He notes, “A drizzle that repeats forever 
            seemed like a funny play on a banal, melancholy, romantic subject, and 
            one whose sentimentality risks crossing the line from pathos into bathos.”</p>

            <p>To create his pattern, Zucker began by making and rendering digital 
            three-dimensional models of raindrops hitting puddles before then 
            compositing and manipulating the resulting images into something 
            that could be translated into a jacquard fabric. He concludes, 
            “This project forced me to think about pattern more literally and 
            rigorously, which was really well timed in terms of the other things I’ve 
            been working on.”</p>
          </div>
        </div>
      </div>
    );
  }
}